<script>
  import { mapActions, mapState } from 'vuex';
  import urlParse from 'url-parse';

  import api from 'src/api';

  import BaseAddingForm from './BaseAddingForm.vue';

  const TYPE_WEB = 'WEB';

  export default {
    name: 'GroupScenariosAddingForm',

    extends: BaseAddingForm,

    props: {
      mode: {
        type: String,
        required: false,
        default: TYPE_WEB,
      },
    },

    computed: {
      ...mapState('groups', ['groupScenarios', 'groupScenariosCount']),
      ...mapState('scenarios', ['scenariosList', 'scenariosCount']),

      title() {
        return this.$t('pages.groups.addingModal.title.scenarios');
      },

      allListTitle() {
        return this.$t('pages.groups.addingModal.all.scenarios');
      },

      addedListTitle() {
        return this.$t('pages.groups.addingModal.inGroup.scenarios');
      },

      allItems() {
        if (this.mode === TYPE_WEB) {
          return this.scenariosList;
        }

        return this.allList;
      },

      allItemsCount() {
        if (this.mode === TYPE_WEB) {
          return this.scenariosCount;
        }

        return this.allCount;
      },

      addedItems() {
        return this.groupScenarios;
      },

      addedItemsCount() {
        return this.groupScenariosCount;
      },
    },

    methods: {
      ...mapActions('groups', [
        'getScenarios',
        'clearScenarios',
        'addScenarios',
        'removeScenarios',
      ]),
      ...mapActions('scenarios', { getAllWebScenarios: 'listWithParams' }),

      itemInEntity(item) {
        return item.isInGroup;
      },

      mapItem(item) {
        if (this.mode === TYPE_WEB) {
          const url = item.origin && urlParse(item.origin);

          return {
            ...item,
            title: item.title?.trim() || '---',
            subtitle: url?.hostname || '---',
          };
        }

        return {
          ...item,
          title: item.title?.trim() || '---',
          subtitle: item.description || '',
        };
      },

      getAddedListMethod() {
        const params = this.currentAddedListParams;

        const queryParams = {
          type: this.mode,
          limit: params.limit,
          page: params.page,
          groupId: this.entity.id,
          ...(params.pattern ? { pattern: params.pattern } : {}),
        };

        return this.getScenarios(queryParams);
      },

      async getAllListMethod() {
        const { limit, page, pattern } = this.currentAllListParams;
        const groupId = this.entity.id;

        if (this.mode === TYPE_WEB) {
          await this.getAllWebScenarios({ limit, page, pattern, groupId });

          return;
        }

        const { response } = await api.desktopScenarios.list({
          params: { limit, page, group_id: groupId, ...(pattern ? { pattern } : {}) },
        });

        this.allList = response.payload;
        this.allCount = response.count;
      },

      removeFromEntityMethod(scenario) {
        return this.removeScenarios({
          groupId: this.entity.id,
          scenarios: [scenario.id],
          type: this.mode,
        });
      },

      addToEntityMethod(scenario) {
        return this.addScenarios({
          groupId: this.entity.id,
          scenarios: [scenario.id],
          type: this.mode,
        });
      },

      clearListsMethod() {
        return this.clearScenarios();
      },
    },
  };
</script>
